import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = ({ data }) => {
  // Validate and transform data
  const months = Object.keys(data || {});

  if (months.length === 0) {
    return (
      <div style={{
        height: "300px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px dashed #ccc",
        borderRadius: "2px"
      }}>
        <p>No data available for the chart</p>
      </div>
    );
  }

  // Define metrics and their display properties
  const metrics = [
    { key: "user_added", label: "Users Added", color: "#4f46e5" },
    { key: "farm_added", label: "Farms Added", color: "#10b981" },
    { key: "satellite_data_added", label: "Satellite Data", color: "#f59e0b" },
    { key: "orders_placed", label: "Orders Placed", color: "#ef4444" },
    { key: "device_added", label: "Devices Added", color: "#8b5cf6" }
  ];

  // Prepare datasets with proper data validation
  const datasets = metrics.map(metric => ({
    label: metric.label,
    data: months.map(month => {
      // Safely get the value or default to 0 if undefined
      const value = data[month]?.[metric.key];
      return typeof value === 'number' ? value : 0;
    }),
    backgroundColor: metric.color,
    borderColor: metric.color,
    borderWidth: 1,
    borderRadius: 4,
    barPercentage: 0.8,
    categoryPercentage: 0.8
  }));

  const chartData = {
    labels: months,
    datasets: datasets,
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 8,
          padding: 8,
          font: {
            size: 9,
          },
        },
      },
      tooltip: {
        bodyFont: {
          size: 9
        },
        backgroundColor: "#1f2937",
        titleColor: "#f9fafb",
        bodyColor: "#f9fafb",
        borderColor: "#4b5563",
        borderWidth: 1,
        padding: 12,
        callbacks: {
          title: (tooltipItems) => `Month: ${tooltipItems[0].label}`,
          label: (context) => {
            const label = context.dataset.label || '';
            const value = context.raw;
            return `${label}: ${value}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 8,
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 8,
          },
        },
      },
    },
    interaction: {
      mode: 'index',
      intersect: false,
    },
  };

  return (
    <div style={{ height: '240px', padding: '8px' }}>
      <Bar data={chartData} options={chartOptions} />
    </div>
  );
};

export default BarChart;